import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IN_ROOM_DINING_ALLERGENS_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { inRoomDiningAllergensSelector } from '../../../servicesSlice';
import InRoomDiningAllergenViewDetail from './Allergen-View-Details';

const InRoomDiningAllergenView = (props) => {
  const { allergen, toggleDrawer, onViewToggle, permissions } = props;
  const inRoomDiningAllergen = useSelector(inRoomDiningAllergensSelector);
  const [tabValue, setTabValue] = useState(0);
  const [currAllergen, setCurrAllergen] = useState(null);

  useEffect(() => {
    if (inRoomDiningAllergen.length) {
      let allergenObj = {
        ...inRoomDiningAllergen.find((temp) => temp.id === allergen.id),
      };
      setCurrAllergen(allergenObj);
    }
  }, [inRoomDiningAllergen]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currAllergen);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_ALLERGENS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return <InRoomDiningAllergenViewDetail tabValue={tabValue} allergen={currAllergen} />;
  };

  return (
    <>
      {currAllergen && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          onViewToggle={onViewToggle}
          title={currAllergen.name}
          createdUserId={currAllergen.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningAllergenView;
